// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tj-z","fullWidth":"Uj-z","heading":"Vj-z","items":"Wj-z","featureCss":"Xj-z","disabled":"Yj-z","imgCss":"Zj-z"};